import api from './client'

export interface J2eeRuntimeHealth {
  reachable: boolean
  ok?: boolean
  projects?: number
  auth_mode?: string
  detail?: string
}

export interface J2eeDeployInfo {
  project: string
  db_mode: string
  biz_logic: string
  bl_dependencies: string[]
  eligible: boolean
  ineligible_reason: string | null
  defaults: {
    runtime_url: string
    admin_token: string
    target_name: string
  }
  runtime: J2eeRuntimeHealth
}

export interface J2eeDeployResult {
  ok: boolean
  runtime_url: string
  target_name: string
  /** Data tenant the app was registered for (URL prefix segment). */
  tenant?: string
  open_url: string
  /** Internal app navigation: {base}/run/{tenant}/{name} */
  app_url: string
  /** Public website: {base}/site/{tenant}/{name} */
  site_url?: string
  summary: {
    db_mode: string
    biz_logic: string
    file_count: number
    bytes_compressed: number
  }
  report: unknown
}

export async function getDeployInfo(project: string): Promise<J2eeDeployInfo> {
  const { data } = await api.get(`/j2ee/deploy-info/${encodeURIComponent(project)}`)
  return data
}

export async function checkRuntimeHealth(runtimeUrl: string): Promise<J2eeRuntimeHealth> {
  const { data } = await api.post('/j2ee/runtime-health', { runtime_url: runtimeUrl })
  return data
}

export async function deployToJ2ee(
  project: string,
  params: { runtime_url: string; admin_token: string; target_name: string }
): Promise<J2eeDeployResult> {
  const { data } = await api.post(`/j2ee/deploy/${encodeURIComponent(project)}`, params)
  return data
}
